import { useMemo } from 'react';
import * as yup from 'yup';
import { FORM_LINE_TYPES } from 'src/components/ui/FormLine/constants';

export const useFormRemoveObjetion = (params = {}) => {
	const { values, options } = params;

	const initialValues = useMemo(() => {
		return {
			objection: null,
			...values,
		};
	}, [values]);

	const shape = useMemo(() => {
		return {
			groups: [
				{
					id: 1,
					lines: [
						{
							id: 1,
							field: {
								type: FORM_LINE_TYPES.autocomplete,
								connected: true,
								params: {
									name: 'objection',
									label: 'Возражение',
									options,
								},
							},
						}
					],
				},
			],
		};
	}, [options]);

	const validationSchema = yup.object().shape({
		objection: yup
			.object()
			.required('Выберите возражение')
	});

	return { shape, initialValues, validationSchema };
};

